export enum SORT_DIRECTION {
	Ascending = 'ASC',
	Descending = 'DESC'
}

export type SortDirection = 'ASC' | 'DESC' | '';
